import { TeamDecisionStore } from 'nomst/Stores/Decision/teamDecision.store';
import { ITeamDecisionDispatcher } from 'typings/teamDecision.dispatcher';
import { EmployeeSort } from 'nomst/Stores/Decision/Constants/employeeSort';

export class TeamDecisionDispatcher implements ITeamDecisionDispatcher {
    private readonly _teamDecisionStore: TeamDecisionStore;

    constructor(teamDecisionStore: TeamDecisionStore) {
        this._teamDecisionStore = teamDecisionStore;
    }

    dispatchIsoCurrencyCodeChanged(isoCurrencyCode: string): void {
        this._teamDecisionStore.handleDispatchIsoCurrencyCodeChanged(isoCurrencyCode);
    }

    dispatchEmployeeSortOptionChanged(employeeSort: EmployeeSort): void {
        this._teamDecisionStore.handleDispatchEployeeSortOptionChanged(employeeSort);
    }

    dispatchPromotionOnlyChanged(promotionOnly: boolean): void {
        this._teamDecisionStore.handleDispatchPromotionOnlyChanged(promotionOnly);
    }
}